import { classNamez } from "@tecreation/funnel-components"
import "./ContentBody.css"

const ContentBody = ({ children, className, scrollable, style }) => {
	return (
		<div className={"px-3 fill pb-4 px-lg-8 " + className + classNamez({ scrollable: scrollable })} style={style}>
			{children}
		</div>
	)
}

export { ContentBody }
